import { send } from 'server';
import { IServerSendResponse, TServerSendRequest } from 'js/hooks/socket/types';
import * as Types from './types';

export const startForgotEmail = ({
    casinoName,
    cellPhone,
    lastName,
    birthDate,
    personalId,
    token
}: Types.IStartForgotEmailRequestData): Promise<IServerSendResponse<Types.IStartForgotEmailResponseData>> => send({
    ID: 35568,
    description: 'Start Forgot Email',
    responses: [35569, 35570],
    casinoName,
    cellPhone,
    lastName,
    birthDate,
    personalId,
    token
} as TServerSendRequest<Types.IStartForgotEmailRequestData>);

export const completeForgotEmail = ({
    casinoName,
    pin,
    token
}: Types.ICompleteForgotEmailRequestData): Promise<IServerSendResponse<Types.ICompleteForgotEmailResponseData>> => send({
    ID: 35571,
    description: 'Complete Forgot Email',
    responses: [35572, 35573],
    casinoName,
    pin,
    token
} as TServerSendRequest<Types.ICompleteForgotEmailRequestData>);
